import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RoleBasedRoute = ({ allowedRoles, children }) => {
  const { roleCode, isLoggedIn,isLoading } = useAuth();

  console.log("roleCode from context:", roleCode);
  console.log("isLoggedIn from context:", isLoggedIn);

if (isLoading) {
    return null; // atau spinner kalau mau
  }

  // Kalau belum login, arahkan ke login
  if (!isLoggedIn) {
    console.log("User is not logged in. Redirecting to login...");
    return <Navigate to="/login" replace />;
  }

  // Kalau tidak punya akses
  if (allowedRoles && !allowedRoles.includes(roleCode)) {
    return <Navigate to="/access-denied" replace />;
  }

  // Kalau punya akses
  return children;
};

export default RoleBasedRoute;
